import { useDispatch, useSelector } from 'react-redux';

import { Icon as CroplerIcon } from '@cropler/ui-kit';

import { selectPhotosType } from '../../store/slices/sensors';
import stylesImageBox from '../ImageBox/styles.module.scss';
import styles from './styles.module.scss';

const PhotosTypeSwitchDark = () => {
  const dispatch = useDispatch();
  const { photosType } = useSelector((state) => state.sensors);

  return (
    <div className={styles.buttonsSwitcher}>
      <button
        className={`
        ${stylesImageBox.imageBoxSwitcherButton} 
        ${(photosType === 'day' || photosType === 'ndvi') && stylesImageBox.imageBoxSwitcherButtonActive}
        `}
        onClick={() => dispatch(selectPhotosType('day'))}
      >
        <CroplerIcon name="day" width={18} />
        RGB
      </button>
      <button
        className={`
        ${stylesImageBox.imageBoxSwitcherButton} 
        ${photosType === 'night' && stylesImageBox.imageBoxSwitcherButtonActive}
        `}
        onClick={() => dispatch(selectPhotosType('night'))}
      >
        <CroplerIcon name="night" width={16} />
        RGB
      </button>
    </div>
  );
};

export default PhotosTypeSwitchDark;
